<template>
    <div class="">
        <Header></Header>

        <!-- Main -->
        <main class="u-main">
            <Navigation></Navigation>

            <div class="u-content">
                <div class="u-body min-h-700">
                    <h1 class="h2 mb-2 text-capitalize"> {{ refs }}

                        <!-- Tenants -->
                        <div class="pull-right ui-mt-15">
                            <span class="btn btn-dark btn-sm">
                                <span class="btn-icon ti-home mr-2"></span>
                                <span> {{ tenant_name }} </span>
                            </span>
                        </div>
                        <!-- End Tenants -->

                    </h1>

                    <!-- Breadcrumb -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'dashboard' }">Home</router-link>
                            </li>
                            <li class="breadcrumb-item text-capitalize">
                                <router-link :to="{ name: refs }">{{ refs }}</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Edit</li>
                        </ol>
                    </nav>
                    <!-- End Breadcrumb -->

            <div v-if="pgLoading" class="row h-100">
                <div class="container text-center">
                    <div class="spinner-grow mt-5" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>

            <form v-if="!pgLoading" @submit.prevent="editRow" enctype="multipart/form-data" class="h-100">

                <!-- Content -->
                <div class="tab-content">
                    <div class="row">  

                    <!-- ********** Cards ******* -->
                    <div class="col-md-8 mb-5">

                        <!-- Card Cabin -->
                        <div class="card">
                            <div class="card-body">
                                <div id="accordion" class="accordion">
                                    <div id="TabCabin" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Cabin')"
                                            aria-expanded="false" 
                                            aria-controls="collapseCabin" 
                                            data-toggle="collapse"
                                            data-target="#collapseCabin">Cabin
                                            <span id="iconToggleCabin" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseCabin" 
                                        class="collapse show" 
                                        aria-labelledby="TabCabin" 
                                        data-parent="#accordion">

                                        <div class="col-12 pt-3">

                                            <!-- Title -->
                                            <div class="form-group">
                                                <label for="input1">Title</label>
                                                <input class="form-control" 
                                                        id="input1" 
                                                        type="text" 
                                                        v-model="row.title" 
                                                        @keyup="onTitleChange">
                                            </div>
                                            <!-- End Title -->

                                            <!-- Slug -->
                                            <div class="form-group">
                                                <label for="input2">Slug</label>
                                                <input class="form-control"
                                                        id="input2"  
                                                        type="text" 
                                                        v-model="row.slug" 
                                                        @keydown.space.prevent 
                                                        @paste="onSlugPaste"
                                                        @change="onSlugChange(false)">
                                            </div>
                                            <!-- End Slug -->

                                            <div class="row">
                                                <!-- Sort -->
                                                <div class="form-group col-6">
                                                    <label for="inputT3">Sort</label>
                                                    <input class="form-control"
                                                            id="input3"  
                                                            type="number"
                                                            min="0" 
                                                            v-model.number="row.sort">
                                                </div>
                                                <!-- End Stars -->

                                                <!-- Price -->
                                                <div class="form-group col-6">
                                                    <label for="input4">Price</label>
                                                    <input class="form-control"
                                                            id="input4"  
                                                            type="number"
                                                            min="0"
                                                            v-model.number="row.price">
                                                </div>
                                                <!-- End Price -->
                                            </div>

                                            <!-- Body -->
                                            <div class="form-group">
                                                <label for="inputEditor1">Body</label>
                                                <editor
                                                    id="inputEditor1"
                                                    v-model="row.body"
                                                    :api-key="editor.api_key"
                                                    :init="{
                                                        height: 300,
                                                        menubar: editor.menubar,
                                                        plugins: editor.plugins,
                                                        external_plugins: editor.external_plugins,
                                                        toolbar: editor.toolbar
                                                    }"
                                                />
                                            </div>
                                            <!-- End Body -->

                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </div>
                        <!-- End Card Cabin -->

                        <!-- Card Icons -->
                        <div class="card mt-5">
                            <div class="card-body">
                                <div id="accordion" class="accordion">
                                    <div id="TabIcons" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Icons')"
                                            aria-expanded="false" 
                                            aria-controls="collapseIcons" 
                                            data-toggle="collapse"
                                            data-target="#collapseIcons">Icons
                                            <span id="iconToggleIcons" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                    pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseIcons" 
                                        class="collapse" 
                                        aria-labelledby="TabIcons" 
                                        data-parent="#accordion">

                                    <div class="col-12 pt-3">
                                    
                                    <!-- For Loop -->
                                    <div v-for="i in row.icons_key" 
                                        :key="i" 
                                        :class="(i == 0) ? 'hidden' : '' " 
                                        :id="'frm_'+i"
                                        class="ui-for-div">

                                        <!-- Remove -->
                                        <div class="pull-right ui-mt-10">
                                            <button v-if="i != 0"
                                                type="button" 
                                                class="btn btn-danger btn-circle btn-with-icon btn-sm" 
                                                @click="removeOption(i)">
                                                <span class="btn-icon ti-close font-bold"></span>
                                            </button>
                                        </div>
                                        <!-- End Remove -->

                                        <!-- image -->
                                        <div class="form-group">
                                            <label :for="'input6'+i">Icon</label>
                                            <p><img v-if="row.icons_image_preview[i]" 
                                                :src="row.icons_image_preview[i]"
                                                class="custom-image">
                                            </p>
                                            <input class="form-control" 
                                                    :id="'input6'+i" 
                                                    type="file"
                                                    ref="myDropify" 
                                                    v-on:change="onIconsImageChange($event, i)">
                                        </div>
                                        <!-- End image -->

                                        <!-- image alt -->
                                        <div class="form-group">
                                            <label :for="'input4'+i">Icon alt</label>
                                            <input class="form-control" 
                                                    :id="'input4'+i" 
                                                    type="text" 
                                                    v-model="row.icons_image_alt[i]">
                                        </div>
                                        <!-- End image alt -->

                                        <!-- image title -->
                                        <div class="form-group">
                                            <label :for="'input5'+i">Icon title</label>
                                            <input class="form-control" 
                                                    :id="'input5'+i" 
                                                    type="text" 
                                                    v-model="row.icons_image_title[i]">
                                        </div>
                                        <!-- End image title -->
                                        
                                    </div>
                                    <!-- End Loop -->

                                        <!-- Add more -->
                                        <div class="row pull-right">
                                            <button type="button" 
                                                class="btn btn-dark btn-circle btn-with-icon"
                                                @click="opnFrm()">
                                                <span class="btn-icon ti-plus font-bold"></span>
                                            </button>
                                        </div>
                                        <!-- End more -->
                                    
                                    </div>
                                
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Card Icons -->

                    </div>
                    <!-- ********** End Cards ******* -->


                    <!-- ******* Navbar ******** -->
                    <div class="col-md-4 mb-5">

                        <!-- Nav Language -->
                        <div class="card">
                            <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="NavLanguage" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Language')" 
                                            aria-expanded="false" 
                                            aria-controls="collapseNavLanguage" 
                                            data-toggle="collapse" 
                                            data-target="#collapseNavLanguage">Language
                                            <span id="iconToggleLanguage" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseNavLanguage" 
                                        class="collapse" 
                                        aria-labelledby="NavLanguage" 
                                        data-parent="#accordionNav">
                                    
                                    <div class="col-12 pt-3">
                                        <!-- Language -->
                                        <div class="form-group">
                                            <div v-if="languageLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <select class="form-control custom-select"
                                                    v-if="!languageLoading" 
                                                    v-model="row.language_id">
                                                    <option value="">Select Language</option>
                                                    <option v-for="(language, index) in languages" 
                                                            :key="index"
                                                            :value="language.id">
                                                            {{ language.name }}
                                                    </option>
                                            </select>
                                        </div>
                                        <!-- End Language -->
                                    </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Nav Language -->
                         <!-- Nav Image -->
                        <div class="card mt-5">
                            <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="NavImage" class="card-header">
                                        <h2 class="h4 card-header-title"
                                            @click="collapseToggle('Image')"  
                                            aria-expanded="false" 
                                            aria-controls="collapseNavImage" 
                                            data-toggle="collapse" 
                                            data-target="#collapseNavImage">Featued Image
                                            <span id="iconToggleImage" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseNavImage" 
                                        class="collapse" 
                                        aria-labelledby="NavImage" 
                                        data-parent="#accordionNav">
                                        <div class="col-12 pt-3">
                                            <!-- Image -->
                                            <div class="form-group">
                                                <label>Image</label>
                                                <img :src="row.image_preview" 
                                                    class="mb-2 custom-image">
                                                <input type="file" 
                                                    class="form-control" 
                                                    ref="myDropify" 
                                                    v-on:change="onImageChange"
                                                    accept="image/*">
                                            </div>
                                            <div class="form-group">
                                                <label>Image alt</label>
                                                <input type="text" 
                                                    class="form-control"
                                                    v-model="row.image_alt">
                                            </div>
                                            <div class="form-group">
                                                <label>Image title</label>
                                                <input type="text" 
                                                    class="form-control"
                                                    v-model="row.image_title">
                                            </div>
                                            <!-- Image -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Nav Image -->

                        <!-- Nav Status -->
                        <div class="card mt-5">
                            <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="NavStatus" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Status')"
                                            aria-expanded="false" 
                                            aria-controls="collapseNavStatus" 
                                            data-toggle="collapse"
                                            data-target="#collapseNavStatus">Status & Visibility
                                            <span id="iconToggleStatus" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseNavStatus" 
                                        class="collapse" 
                                        aria-labelledby="NavStatus" 
                                        data-parent="#accordionNav">
                                        <div class="col-12 pt-3">
                                            <!-- Status -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox" 
                                                        class="custom-control-input" 
                                                        id="customSwitch1" 
                                                        :checked="row.status"
                                                        @click="onStatus">
                                                    <label class="custom-control-label" 
                                                        for="customSwitch1"
                                                        v-html="(row.status) ? 'Active' : 'Inactive'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End Status -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Nav Status -->

                    </div>
                    <!-- ******** End Navbar ******** -->

                </div>
            </div>
            <!-- End Content -->

                    

                    <div class="col-md-12 row">
                        <div class="form-group mr-2">
                            <button class="btn btn-primary" :disabled="btnLoading">
                                <span v-if="btnLoading">
                                    <span class="spinner-grow spinner-grow-sm mr-1" 
                                        role="status" aria-hidden="true">
                                    </span>Loading...
                                </span>
                                <span v-if="!btnLoading" class="ti-check-box"></span>
                                <span v-if="!btnLoading"> Update Cabin</span>
                            </button>
                        </div>

                        <div class="form-group">
                            <button type="button" class="btn btn-danger" 
                                :disabled="btnLoading" 
                                @click="cancel">
                                <span class="ti-close"></span>
                                <span> Cancel </span>
                            </button>
                        </div>
                    </div>


                </form>
            </div>


                <Footer></Footer>
            </div>
        </main>
        <!-- End Main -->
        
    </div>
</template>

<script>
    import Header from '../layouts/Header.vue';
    import Navigation from '../layouts/Navigation';
    import Footer from '../layouts/Footer.vue';
    import Editor from '@tinymce/tinymce-vue';
    import iziToast from 'izitoast';
    
    export default {
        name: 'Edit',
        components: {
            Header,
            Navigation,
            Footer,
            Editor
        },
        data(){
            return {
                //
                auth: {
                    role: '',
                    access_token: '',
                },
                row: {
                    // row
                    title: '',
                    slug: '',
                    sort: 0,
                    price: '',
                    body: '',

                    // icons
                    icons: [],
                    icons_key: 0,
                    icons_image_preview: [],
                    icons_image_base64: [],
                    icons_image_alt: [],
                    icons_image_title: [],

                    //language
                    language_id: '',

                    // image
                    image_preview: '',
                    image_base64: '',
                    image_alt: '',
                    image_title: '',

                    // status & visibility
                    status: 1,
                },
                editor: {
                    api_key: window.editor_apiKey,
                    menubar: window.editor_menubar,
                    plugins:[window.editor_plugins],
                    external_plugins: window.editor_external_plugins,
                    toolbar: window.editor_toolbar,
                },

                pgLoading: true,
                btnLoading: false,

                // Tenants
                tenant_id: 0,
                tenant_name: '',
                refs: 'cabins',

                // language
                languages: [],
                languageLoading: true,
            }
        },
        mounted() {},
        computed: {},
        created() {
            // AccessToken & Role
            if(localStorage.getItem('role')) {
                this.auth.role = localStorage.getItem('role');
            }
            if(localStorage.getItem('access_token')) {
                this.auth.access_token = localStorage.getItem('access_token');
            }

            // Tenants
            if(localStorage.getItem('tenant_id')) {
                this.tenant_id = localStorage.getItem('tenant_id');
            }
            if(localStorage.getItem('tenant_name')) {
                this.tenant_name = localStorage.getItem('tenant_name');
            }

            this.fetchRow();
        },
        methods: {
            
            
            // fetch Row
            fetchRow() {
                this.pgLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/'+this.refs+'/'+this.$route.params.id,
                    method: 'GET',
                    data: {},
                    params: {},
                }
                this.axios(options)
                    .then(res => {
                    this.pgLoading = false;

                    // tenant
                    this.tenant_id = res.data.row.tenant_id;
                    this.tenant_name = res.data.row.tenant_name;

                    // row
                    this.row.title = res.data.row.title;
                    this.row.slug = res.data.row.slug;
                    this.row.sort = res.data.row.sort;
                    this.row.price = res.data.row.price;
                    this.row.body = res.data.row.body;

                    // icons
                    this.row.icons_key = res.data.row.icons.length;
                    if(res.data.row.icons) {
                        for(let i = 1; i <= this.row.icons_key; i++) {
                            let x = i-1;
                            this.row.icons_image_preview[i] = (res.data.row.icons[x]) 
                                                            ? res.data.row.icons[x].image_url
                                                            : ''; 
                            this.row.icons_image_base64[i] = (res.data.row.icons[x]) 
                                                            ? res.data.row.icons[x].image_url
                                                            : ''; 
                            this.row.icons_image_alt[i] = (res.data.row.icons[x]) 
                                                            ? res.data.row.icons[x].image_alt
                                                            : ''; 
                            this.row.icons_image_title[i] = (res.data.row.icons[x]) 
                                                            ? res.data.row.icons[x].image_title
                                                            : ''; 
                            
                        }
                    }

                    //language
                    this.row.language_id = (res.data.row.language) ? res.data.row.language.id : null;
                    // image
                    this.row.image_preview = (res.data.row.image) ? res.data.row.image.image_url : null;
                    this.row.image_base64 = (res.data.row.image) ? res.data.row.image.image_url : null;
                    this.row.image_alt = (res.data.row.image ) ? res.data.row.image.image_alt : null;
                    this.row.image_title = (res.data.row.image ) ? res.data.row.image.image_title : null;

                    // status & visibility
                    this.row.status = res.data.row.status;

                    this.fetchLanguages(); // call next func
                    })
                    .catch(() => {})
                    .finally(() => {});
            },
            // fetch Language
            fetchLanguages(){
                this.languageLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/languages',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.languageLoading = false;
                        this.languages = res.data.rows;
                    })
                    .catch(() => {})
                    .finally(() => {});
            },

            // Edit row
            editRow(){
                if(this.tenant_id == 0) {
                    
                    iziToast.warning({
                        icon: 'ti-alert',
                        title: 'Wow-man,',
                        message: 'No tenany selected.'
                    });

                } else {
                    this.btnLoading = true;
                    this.axios.defaults.headers.common = {
                        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                        'Authorization': `Bearer ` + this.auth.access_token,
                    };
                    // items
                    for( let i = 1; i <= this.row.icons_key; i++ ) {
                        this.row.icons[i] = {
                            'icon_base64' : this.row.icons_image_base64[i],
                            'icon_alt' : this.row.icons_image_alt[i],
                            'icon_title' : this.row.icons_image_title[i]
                        }
                    }
                    const options = {
                        url: window.baseURL+'/'+this.refs+'/'+this.$route.params.id,
                        method: 'PUT',
                        data: {
                            tenant_id: this.tenant_id,
                            // row
                            title: this.row.title,
                            slug: this.row.slug,
                            sort: this.row.sort,
                            price: this.row.price,
                            body: this.row.body,

                            // icons
                            icons: this.row.icons,

                            //language
                            language_id: this.row.language_id,
                            
                            // image
                            image_base64: this.row.image_base64,
                            image_alt: this.row.image_alt,
                            image_title: this.row.image_title,

                            // status & visibility
                            status: this.row.status,
                        }
                    }
                    this.axios(options)
                        .then(() => {
                            this.btnLoading = false;
                            iziToast.success({
                                icon: 'ti-check',
                                title: 'Great job,',
                                message: 'Item Updated Successfully.',
                            });
                            this.$router.push({ name: this.refs });
                        })
                        .catch(err => {
                            // 403 Forbidden
                            if(err.response && err.response.status == 401) {
                                this.removeLocalStorage();
                                this.$router.push({ name: 'login' });
                            } else if(err.response && err.response.status == 403) {
                                this.$router.push({ name: 'forbidden' });
                            } else {
                                this.btnLoading = false;
                                iziToast.warning({
                                    icon: 'ti-alert',
                                    title: 'Wow-man,',
                                    message: (err.response) ? err.response.data.message : ''+err
                                });
                            }
                        })
                        .finally(() => {})
                }
            },

            // Title
            onTitleChange() {
                // this.onSlugChange(this.row.title);
            },

            // on Paste
            onSlugPaste(){
                let str = this.row.slug;
                this.onSlugChange(str);
            },
            onSlugChange(str=''){
                if(!str) {
                    str = this.row.slug;
                }
                this.row.slug = str.replace(/\s+/g, '-');
            },


            // Upload Featured image
            onImageChange(e){
                const file = e.target.files[0];
                this.row.image_preview = URL.createObjectURL(file);
                this.createBase64Image(file);
            },
            createBase64Image(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image_base64 = e.target.result;
                };
            },

            onIconsImageChange(e, i) {
                const file = e.target.files[0];
                this.row.icons_image_preview[i] = URL.createObjectURL(file);
                this.createIconsBase64Image(file, i);
            },
            createIconsBase64Image(fileObject, i){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.icons_image_base64[i] = e.target.result;
                };
            },

            // items add more
            opnFrm() {
                this.row.icons_key++;
            },
            removeOption(i) {
                document.querySelector('#frm_'+i).remove();
                this.row.icons_image_preview[i] = '';
                this.row.icons_image_base64[i] = '';
                this.row.icons_image_alt[i] = '';
                this.row.icons_image_title[i] = '';
            },

            // active status
            onStatus(){
                if(this.row.status)
                    this.row.status = 0;
                else
                    this.row.status = 1;
            },

            // remove sessions
            removeLocalStorage() {
                localStorage.removeItem('access_token');
                localStorage.removeItem('user_image');
                localStorage.removeItem('user_name');
                localStorage.removeItem('user_id');
                localStorage.removeItem('role');
                localStorage.removeItem('tenant_id');
            },

            // toggleCollapse
            collapseToggle(div) {
                let el = document.querySelector("span#iconToggle"+div);
                if(el.classList.contains('ti-angle-down')) {
                    el.classList.remove('ti-angle-down');
                    el.classList.add('ti-angle-up');
                } else {
                    el.classList.remove('ti-angle-up');
                    el.classList.add('ti-angle-down');
                }
            },

            // Cancel
            cancel(){
                if(confirm('Are You Sure?')) {
                    this.$router.push({ name: this.refs });
                }
            },

        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
